var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStaywithMonitor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 24 20.625",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.1875 0H2.8125C1.26169 0 0 1.26169 0 2.8125V14.0625C0 15.6133 1.26169 16.875 2.8125 16.875H11.0625V18.75H6.1875V20.625H17.8125V18.75H12.9375V16.875H21.1875C22.7383 16.875 24 15.6133 24 14.0625V2.8125C24 1.26169 22.7383 0 21.1875 0ZM22.125 14.0625C22.125 14.5794 21.7044 15 21.1875 15H2.8125C2.29556 15 1.875 14.5794 1.875 14.0625V2.8125C1.875 2.29556 2.29556 1.875 2.8125 1.875H21.1875C21.7044 1.875 22.125 2.29556 22.125 2.8125V14.0625Z",
    fill: "var(--fill-0, white)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaywithMonitor);
export default __webpack_public_path__ + "static/media/staywith-monitor.a3fe2be131708773d11ccecd57dc4863.svg";
export { ForwardRef as ReactComponent };